import { useContext, useState } from 'react'
import {
  useLoaderData,
  Navigate
} from 'react-router-dom'
import { getEmailVerification, verifyEmail } from '../../lib/allauth'
import { Button, Box, Typography, TextField, IconButton } from '@mui/material';
import { styled } from '@mui/system';
import { useNavigate } from 'react-router-dom';
import BackgroundContainer from '../../components/BackgroundContainer';
import BaseHeader from '../../components/BaseHeader';
import BaseButton from '../../components/BaseButton';
import BaseTextField from '../../components/BaseTextField';
import BaseFormContainer from '../../components/BaseFormContainer';
import { AuthContext } from '../../auth/AuthContext';


const Subtitle = styled(Typography)({
  fontFamily: 'Playfair Display, serif',
  fontSize: '1.5rem',
  color: '#ffbfe1',
  textAlign: 'center',
  textShadow: '0px 2px 6px rgba(0, 0, 0, 0.5)',
  lineHeight: '1.4',
});

export async function loader ({ params }) {
  const key = params.key
  const resp = await getEmailVerification(key)
  return { key, verification: resp }
}

export default function VerifyEmail () {
  const { key, verification } = useLoaderData()
  const { refreshAuth } = useContext(AuthContext);
  const [response, setResponse] = useState({ fetching: false, content: null })
  const navigate = useNavigate();

  function submit () {
    setResponse({ ...response, fetching: true });
  
    verifyEmail(key)
      .then(async (content) => {
        setResponse((r) => ({ ...r, content }));
  
        // 🔄 Refresh the auth state after successful verification
        await refreshAuth();
      })
      .catch((e) => {
        console.error(e);
        window.alert(e);
      })
      .finally(() => {
        setResponse((r) => ({ ...r, fetching: false }));
      });
  }
  

  if ([200, 401].includes(response.content?.status)) {
    return <Navigate to='/account/email' />
  }

  let body = null
  if (verification.status === 200) {
    body = (
      <>
 <Subtitle sx={{ fontSize: '1.3rem' }} color="white" align="center" marginBottom={2}>
  Please confirm that{' '}
  <span style={{ color: '#ff70ba', fontWeight: 500 }}>
    {verification.data.email}
  </span>{' '}
  is your email.
</Subtitle>
        <BaseButton disabled={response.fetching} onClick={() => submit()}>Confirm</BaseButton>
      </>
    )
  } else if (!verification.data?.email) {
    body = (<>
    <Subtitle sx={{ fontSize: '1.3rem' }} color="white" align="center" marginBottom={2}>Invalid verification link.</Subtitle>
    <BaseButton onClick={() => navigate('/')}>Go To Main Page</BaseButton>
    </>)
  } else {
    body = <Subtitle sx={{ fontSize: '1.3rem' }} color="white" align="center" marginBottom={2}>Unable to confirm email <span style={{ color: '#ff70ba', fontWeight: 500 }}>
    {verification.data.email}
  </span>{' '} because it is already confirmed.</Subtitle>
  }
  return (
    <BackgroundContainer>
      <BaseFormContainer>
      <Box display="flex" flexDirection="column" alignItems="center" >
      <BaseHeader sx={{ fontSize: '2rem' }} >Confirm Email Address</BaseHeader >
      {body}
      </Box>
      </BaseFormContainer>
    </BackgroundContainer>
  )
}
